export default "__VITE_ASSET__4bfff270__"